import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InvestigatorEQueryDetailsDialogComponent} from './e-query-details/investigator-e-query-details-dialog.component';
import {SharedModule} from '../../../shared';
import {SimpleTextFieldModule} from '../../../simple-text-field/simple-text-field.module';
import {GlobalPopupModule} from '../../../global-popup';
import { InvestigatorAwaitingEQueriesComponent } from './awaiting/investigator-awaiting-e-queries.component';
import { InvestigatorSubmittedEQueriesComponent } from './submitted/investigator-submitted-e-queries.component';
import { InvestigatorEQueryTabsComponent } from './investigator-e-query-tabs.component';
import { InvestigatorEQueryGridComponent } from './investigator-e-query-grid.component';
import { EQueriesModule } from '../../../e-queries/e-queries.module';
import { InvestigatorEQueriesColumns } from './investigator-e-queries-columns';
import {ReactiveFormsModule} from '@angular/forms';
import {CovanceFileUploadModule} from '../../../covance-file-upload/covance-file-upload.module';

export const COMPONENTS = [
    InvestigatorAwaitingEQueriesComponent,
    InvestigatorSubmittedEQueriesComponent,
    InvestigatorEQueryTabsComponent,
    InvestigatorEQueryGridComponent,
    InvestigatorEQueryDetailsDialogComponent
];

@NgModule({
    declarations: [COMPONENTS],
    exports: [COMPONENTS],
    imports: [
        CommonModule,
        SharedModule,
        SimpleTextFieldModule,
        GlobalPopupModule,
        ReactiveFormsModule,
        GlobalPopupModule,
        EQueriesModule,
        CovanceFileUploadModule,
    ],
    entryComponents: [
        InvestigatorEQueryDetailsDialogComponent
    ],
    providers: [
        InvestigatorEQueriesColumns
    ]
})

export class InvestigatorEQueryModule { }
